export function IsStartWithNumber(input: string) {
  const startNumberExp = /^\d/;
  return startNumberExp.test(input);
}

export function IsHaveThaiText(input: string) {
  const thRegExp = /[กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุูเแโใไๅๆ็่้๊๋์]/;
  return thRegExp.test(input);
}
